const state = {
  paymentContext: null,
};

const getters = {
  getPaymentContext: (stateParam) => stateParam.paymentContext,
};

const mutations = {
  setPaymentContext(stateParam, data) {
    // eslint-disable-next-line no-param-reassign
    stateParam.paymentContext = data;
  },
  clearPaymentContext(stateParam) {
    // eslint-disable-next-line no-param-reassign
    stateParam.paymentContext = null;
  },
};

const actions = {
  // Actions for payment processing if needed
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
